export default __webpack_public_path__ + "static/media/logo-linkedin-2.a79516f9.svg";